module.exports = __webpack_public_path__ + "static/media/circo2022_social.cadd0bf4.jpg";